import React from "react";
import {useTranslation} from "react-i18next";
import logo from "../../assets/logo-web.png";

// Libs
import {boxShadow, primaryColor, textColor} from "../libs/theme-lib";

// Hooks
import {useAuth} from "../../auth/auth";

const ForbiddenPage = (props) => {
    const {userType} = useAuth();

    const {t} = useTranslation("common");

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            flex: 1
        }}>
            <div style={{paddingBottom: 15}}>
                {userType === "client" && (
                    <div style={{
                        color: primaryColor,
                        fontSize: 28,
                        fontWeight: "bold"
                    }}>{t("forbiddenTitle")}</div>
                )}
            </div>
            <div style={{
                backgroundColor: "white",
                boxShadow: boxShadow,
                padding: 15,
                flex: 1,
                display: "flex",
                flexDirection: "column",
                color: textColor
            }}>
                <div style={{margin: "auto"}}>
                    <img src={logo} style={{display: "block", margin: "30px auto"}} />
                    <h3 style={{fontSize: 24}}>{t("forbiddenText")}</h3>
                </div>
            </div>
        </div>
    );
};

export default ForbiddenPage;